<template>
    <v-card>
        <v-card-title class="headline">Đổi thiết bị của xe {{vehicle.plate}}?</v-card-title>
        <v-card-text>
            <v-form v-model="switchDeviceForm.isValid" ref="switchDeviceForm">
                <v-text-field
                    label="Imei hiện tại"
                    mask="################"
                    disabled
                    :value="vehicle.imei"
                ></v-text-field>
                <v-text-field
                    label="Imei mới"
                    mask="################"
                    v-model="switchDeviceForm.imei"
                    :rules="[validate.required, validate.numeric]"
                ></v-text-field>
                <v-text-field
                    label="SĐT mới"
                    mask="############"
                    v-model="switchDeviceForm.simPhone"
                    :rules="[validate.numericOrEmpty]"
                ></v-text-field>
                <v-textarea
                    label="Lý do đổi thiết bị"
                    v-model="switchDeviceForm.remark"
                    :rules="[validate.required]"
                ></v-textarea>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="$emit('show', false)">Từ chối</v-btn>
            <v-btn
                flat
                color="primary"
                @click.native="switchDeviceSubmit()"
                :loading="switchDeviceForm.isLoading"
            >Đồng ý</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import validate from '@/utils/validate';

export default {
  props: {
    vehicle: Object
  },
  data () {
    return {
      validate: validate,
      switchDeviceForm: {
        isValid: false,
        isLoading: false,
        imei: '',
        simPhone: '',
        remark: ''
      },
    };
  },
  methods: {
    ...mapActions(['switchDevice']),
    
    switchDeviceSubmit () {
      if (this.switchDeviceForm.isValid) {
        this.switchDeviceForm.isLoading = true;
        this.switchDevice({
          vehicleId: this.vehicle.id,
          imei: this.switchDeviceForm.imei,
          remark: this.switchDeviceForm.remark
        })
          .then(res => {
            this.$emit('show', false);
            window.getApp.showMessage(
              `Đổi thiết bị cho xe ${this.vehicle.plate} thành công`
            );
            setTimeout(() => {
              window.location.reload();
            }, 500);
          })
          .catch(code => {
            let msg = '';

            if (code === validate.ERR_IMEI_NOT_EXIST) {
              msg = 'Số Imei không tồn tại';  
            }

            if (code === validate.ERR_IMEI_USED) {
              msg = 'Số Imei đã được sử dụng';  
            }

            if (code === validate.ERR_VEHICLE_NOT_EXIST) {
              msg = 'Xe này không tồn tại';  
            }

            window.getApp.showMessage(msg, 'error');
            
          }).finally(_ => {
            this.switchDeviceForm.isLoading = false;
          });
      } else {
        this.$refs.switchDeviceForm.validate();
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/vehicle/components/SwitchDevice.vue